import React from 'react';
import { useResource } from 'new/components/monitor/ResourceTriage/useResource';
import {
  RESOURCE_TYPE_CREDENTIALS,
  RESOURCE_TYPE_DATA_MAP,
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_FLOW,
  RESOURCE_TYPE_RECORD_TRANSFORM,
  RESOURCE_TYPE_SCHEMA_SPECS,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_SOURCE,
} from 'js/constants/resourceTypes';
import { SourceOverview } from 'new/elements/Overview/Source';
import { NexsetOverview } from 'new/elements/Overview/Nexset';
import { DestinationOverview } from 'new/elements/Overview/Destination';
import { CredentialOverview } from 'new/elements/Overview/Credentials';
import { LookupOverview } from 'new/elements/Overview/Lookup';
import { SchemaSpecOverview } from 'new/elements/Overview/SchemaSpec';
import { FlowOverview } from 'new/elements/Overview/Flows';
import { ReusableTxOverview } from './ReusableTx';

interface OverviewProps {
  resourceId: string;
  resourceType: string;
  onItemClick?: (type: string, data: any) => void;
}

const Components = {
  [RESOURCE_TYPE_SOURCE]: SourceOverview,
  [RESOURCE_TYPE_FLOW]: FlowOverview,
  [RESOURCE_TYPE_DATA_SET]: NexsetOverview,
  [RESOURCE_TYPE_SINK]: DestinationOverview,
  [RESOURCE_TYPE_CREDENTIALS]: CredentialOverview,
  [RESOURCE_TYPE_DATA_MAP]: LookupOverview,
  [RESOURCE_TYPE_SCHEMA_SPECS]: SchemaSpecOverview,
  [RESOURCE_TYPE_RECORD_TRANSFORM]: ReusableTxOverview,
};

export const Overview = (props: OverviewProps) => {
  const { resourceId, resourceType, onItemClick } = props;
  const { resource } = useResource(resourceType, resourceId);
  const Component = Components[resourceType] || SourceOverview;
  return <Component resource={resource} onFlowItemClick={onItemClick} />;
};
